import React from "react";
import { Box, Typography, keyframes } from "@mui/material";

const typingBounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.35;
  }
  30% {
    transform: translateY(-3px);
    opacity: 1;
  }
`;

/**
 * Bolha estilo WhatsApp (“digitando…”) para simuladores de ChatBot / Agente.
 */
export default function SimulatorTypingBubble({ label = "Digitando…" }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        mt: 0.5,
        alignSelf: "flex-start",
      }}
      aria-live="polite"
      aria-label={label}
    >
      <Box
        sx={{
          maxWidth: "78%",
          px: 1.5,
          py: 1,
          borderRadius: 2,
          bgcolor: "grey.200",
          display: "flex",
          alignItems: "center",
          gap: 0.85,
          minHeight: 32,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, height: 14 }}>
          {[0, 1, 2].map((index) => (
            <Box
              key={index}
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                bgcolor: "text.secondary",
                animation: `${typingBounce} 1.2s ease-in-out infinite`,
                animationDelay: `${index * 0.15}s`,
              }}
            />
          ))}
        </Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontStyle: "italic", lineHeight: 1.2, userSelect: "none" }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
}
